export const addPage = (page, data) => {
	return { type: 'ADD_PAGE', page, data }
}

export const removePage = () => {
	return { type: 'REMOVE_PAGE' }
}

export const setPage = (page, data) => {
	return { type: 'SET_PAGE', page, data }
}

export const updatePage = (page, data) => {
	return { type: 'UPDATE_PAGE', page, data }
}



// WEBPACK FOOTER //
// ./src/redux/nav.js